import moment from "moment";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import FieldSetComponent from "@/components/child/form/fieldset";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import Grid from "@/components/child/grid/grid";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnExt, GridColumnType } from "@/components/child/grid/gridColumn";
import multiSelectComponent from "@/components/child/multiSelect/multiSelect.vue";
import { Component, Watch } from "@/decorators";
import CompraFornecedorModel from "@/models/compraFornecedorModel";
import CompraItemModel from "@/models/compraItemModel";
import CompraModel from "@/models/compraModel";
import CurvaABC from "@/models/enum/produto/curvaABC";
import SituacaoCompra from "@/models/enum/situacaoCompra";
import TiposCompra from "@/models/enum/tiposCompra";
import FornecedorModel from "@/models/fornecedorModel";
import PaginationModel from "@/models/paginationModel";
import ProdutoModel from "@/models/produto/produtoModel";
import CompraService from "@/services/compraService";
import FornecedorService from "@/services/fornecedorService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import produtoService from "@/services/produto/produtoService";
import { SessionActions } from "@/store/store";
import { sortArray } from "@/utils/common/array";
import { getFornecedorCombo } from "@/utils/common/combo/combotext";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        dateTimePickerComponent,
        fieldsetComponent,
        multiSelectComponent,
        buttonIncluirComponent,
        comboComponent,
        dataTooltipComponent,
        decimalComSinalCustomComponent,
        gridComponent,
    },
    computed: {
        compraTitle() {
            const path = "__.Crud.compras.edit_vue_html.";
            if (this.modelId == 0) {
                return this.$t(path + "compraEdit");
            }
            return `${this.$t(path + "compraCod")}<span style="color: mediumblue">${this.model.codigo}</span>${this.$t(
                path + "edit",
            )}`;
        },
    },
})
export default class ComprasEditComponent extends EditComponentBase<CompraModel> {
    private gridcomponent: Grid = null;
    private fieldsetComponent: FieldSetComponent = null;

    grupoProdutoOptions: Array<Object> = [];
    grupoProdutoSelected: Array<number> = [];
    produtosOptions: Array<Object> = [];
    fornecedoresOptions: Array<Object> = [];
    extraActions: Array<object> = [];
    extraActionsFornecedores: Array<object> = [];

    tipoCompra = 0;
    curvaAbc = 0;
    gridData: Array<CompraItemModel> = [];
    gridDataFornecedores: Array<CompraFornecedorModel> = [];
    produtoId = 0;
    pags = false;
    tipoDocGerar: number = null;
    fornecedorModel = new CompraFornecedorModel();
    showFornecedores = false;
    private compraService = new CompraService();
    isEditableColunaQtdCompra = false;

    private dataInicial = moment(new Date()).subtract(1, "month").startOf("month").toDate();
    private dataFinal = moment(new Date()).subtract(1, "month").endOf("month").toDate();

    tipoOptions: Array<Object> = [{ text: "Consumo", value: TiposCompra.Consumo }];

    curvaAbcOptions: Array<Object> = [
        { text: "Geral", value: 0 },
        { text: "A", value: CurvaABC.A },
        { text: "B", value: CurvaABC.B },
        { text: "C", value: CurvaABC.C },
    ];

    get gridColumnsFornecedores(): Array<GridColumn> {
        return [new GridColumn("fornecedorDescricao", "Fornecedor", GridColumnType.String, false, false, "", "", true)];
    }

    private get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("produtoDescricao", this.$t("__.ts.descricao") as string, GridColumnType.String),
            new GridColumn("curvaAbcDescricao", "Curva ABC", GridColumnType.String),
            new GridColumn("grupoProdutoDescricao", this.$t("__.ts.grupo") as string, GridColumnType.String),
            new GridColumn("estoqueMinimo", this.$t("__.ts.estoqueMin") as string, GridColumnType.String),
            new GridColumn("estoqueMaximo", this.$t("__.ts.estoqueMax") as string, GridColumnType.String),
            new GridColumn("quantidadeVendida", this.$t("__.ts.qtdVendida") as string, GridColumnType.Decimal),
            new GridColumn("valorVendido", this.$t("__.ts.valorVendido") as string, GridColumnType.Money),
            new GridColumn("consumoDiario", this.$t("__.ts.consumoDiario") as string, GridColumnType.Decimal),
            new GridColumn("quantidadeAtual", this.$t("__.ts.qtdAtual") as string, GridColumnType.Decimal),
            new GridColumn("valorCusto", this.$t("__.ts.valorCusto") as string, GridColumnType.Money),
            new GridColumnExt({
                value: "quantidadeCompra",
                text: this.$t("__.ts.qtdComprar") as string,
                type: GridColumnType.Decimal,
                editable: this.isEditableColunaQtdCompra,
                onChange: (item: CompraItemModel, index: number) => this.onChangeQuantidadeComprar(item, index),
            }),
        ];
    }

    private async onConsolidar() {
        if (await this.$validator.validateAll()) {
            const filters = {
                grupoProdutoIds: this.grupoProdutoSelected.map(p => p["value"]),
                produtosFixosIds: this.gridData.map(p => p.produtoId),
                produtos: this.gridData,
                tipoCompra: this.tipoCompra,
                dataInicial: this.dataInicial,
                dataFinal: this.dataFinal,
                dias: this.model.dias,
                margemTolerancia: this.model.margemTolerancia,
                curvaAbc: this.curvaAbc,
                fornecedores: this.gridDataFornecedores,
            };

            const data = await this.compraService
                .consolidar(filters)
                .withLoading()
                .resolveWithJSON<CompraItemModel[]>();

            if (data.length > 0) {
                this.gridData = data;
                this.gridDataFornecedores = this.gridData[0].produtoFornecedores;

                await this.loadFornecedores();

                if (this.gridData.length > 0) {
                    this.fieldsetComponent = this.$refs.fieldsetComponent as FieldSetComponent;
                    this.fieldsetComponent.isCollapsed = true;
                    this.showFornecedores = true;
                } else {
                    await this.$showWarning(
                        this.$t("__.ts.atencao"),
                        "Nenhum item foi encontrado para os filtros selecionados",
                    );
                }
            }
        }
    }

    private onChangeQuantidadeComprar(item: CompraItemModel, index: number) {
        this.gridData[index].quantidadeCompra = item.quantidadeCompra;
    }

    public async onLoadModel(model: CompraModel) {
        this.gridData = model.itens;
        this.dataInicial = model.dataInicial;
        this.dataFinal = model.dataFinal;
        this.tipoCompra = model.tipoCompra;

        this.showFornecedores = !!this.model.id;

        if (model.fornecedores.length > 0) {
            this.gridDataFornecedores = model.fornecedores;
            this.loadFornecedores();
        }
    }

    private onRemove(item: CompraItemModel) {
        this.gridData = this.gridData.filter(i => i !== item);
    }

    private onRemoveFornecedores(item: CompraFornecedorModel) {
        this.gridDataFornecedores = this.gridDataFornecedores.filter(
            fornecedor => fornecedor.fornecedorId !== item.fornecedorId,
        );

        this.loadFornecedores();
    }

    public async onPreSave() {
        this.model.dataInicial = this.dataInicial;
        this.model.dataFinal = this.dataFinal;
        this.model.tipoCompra = this.tipoCompra;
        this.model.itens = this.gridData;
        this.model.fornecedores = this.gridDataFornecedores;

        return true;
    }

    @Watch("pags")
    private onPags() {
        if (this.pags) {
            this.gridcomponent = this.$refs.gridcomponent as Grid;

            if (this.tipoDocGerar == 0) {
                setTimeout(() => {
                    this.gridcomponent.gerarXls();
                }, 2000);
            }

            if (this.tipoDocGerar == 1) {
                setTimeout(() => {
                    this.gridcomponent.gerarPdf();
                }, 2000);
            }

            if (this.tipoDocGerar == 2) {
                setTimeout(() => {
                    this.gridcomponent.gerarImpressao();
                }, 2000);
            }

            setTimeout(() => {
                this.pags = false;
            }, 2000);
        }
    }

    public async onAfterLoadModel(model: CompraModel) {
        this.somenteConsulta = model.situacao === SituacaoCompra.Concluido;
    }

    private async onInclusaoCompraItem() {
        const produto = this.$el.querySelector("#produtoId") as HTMLSelectElement;

        if (this.produtoId > 0) {
            const alreadyExists = this.gridData.filter(f => f.produtoId == this.produtoId).length > 0;

            if (!alreadyExists) {
                const compraItem = new CompraItemModel();
                const dataValorCusto = await produtoService
                    .getById(this.produtoId)
                    .withLoading()
                    .resolveWithJSON<ProdutoModel>();

                compraItem.produtoDescricao = produto.innerText;
                compraItem.produtoId = this.produtoId;
                compraItem.valorCusto = dataValorCusto.valorCusto ?? 0;
                compraItem.compraId = 0;
                compraItem.quantidadeCompra = 0;

                this.gridData.push(compraItem);

                this.loadProdutos();
                this.produtoId = 0;
            }
        }
    }

    private async loadFornecedores() {
        try {
            const data = await new FornecedorService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<FornecedorModel>>();

            this.fornecedoresOptions = data.list
                .filter(
                    p =>
                        p.id != this.fornecedorModel.id &&
                        !this.gridDataFornecedores.some(item => item.fornecedorId === p.id),
                )
                .map(getFornecedorCombo);

            this.extraActions.splice(0);
            this.extraActionsFornecedores.splice(0);

            for (let i = 0; i < this.gridDataFornecedores.length; i++) {
                this.extraActionsFornecedores.push(
                    new GridAction(
                        "copy-link-cotacao",
                        "Copiar Link da Cotação",
                        "fa fa-link",
                        GridColors.GREEN,
                        this.gridDataFornecedores[i].key != "",
                    ),
                );
            }

            this.extraActions.push(this.extraActionsFornecedores);
        } catch {}
    }

    private async onExtraAction(name: string, fornecedor: CompraFornecedorModel) {
        if (name.trim() == "copy-link-cotacao") {
            await navigator.clipboard.writeText(
                `${process.env.VUE_APP_ROOT_FRONT}/cotacao-fornecedor/${fornecedor.key}`,
            );
            this.$notifyInfo("", "Link copiado para a área de transferência");
        }
    }

    private onInclusaoItem() {
        const fornecedor = this.$el.querySelector("#fornecedorId") as HTMLSelectElement;
        const compraFornecedor = new CompraFornecedorModel();
        compraFornecedor.fornecedorId = this.fornecedorModel.fornecedorId;
        compraFornecedor.fornecedorDescricao = fornecedor.innerText;
        this.gridDataFornecedores.push(compraFornecedor);
        this.loadFornecedores();
        this.fornecedorModel.fornecedorId = null;
    }

    private onChangeSortFornecedores(sortKey: keyof CompraFornecedorModel, sortOrder: "asc" | "desc") {
        sortArray(this.gridDataFornecedores, sortKey, sortOrder);
    }

    private onChangeSort(sortKey: keyof CompraItemModel, sortOrder: "asc" | "desc") {
        sortArray(this.gridData, sortKey, sortOrder);
    }

    private async loadProdutos(refresh = false) {
        try {
            const data = await produtoService.comboCached(this.usuarioLogado.franquiaId, refresh);
            this.produtosOptions = data.filter(
                p =>
                    p.subGrupo != null &&
                    p.subGrupo >= 0 &&
                    p.value != this.produtoId &&
                    this.gridData.filter(i => i.produtoId == p.value).length == 0,
            );
        } catch {}
    }

    private async beforeMount() {
        await this.setProps(new CompraService(), "compras", new CompraModel());
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        if (!this.usuarioLogado.franquia.moduloCompras) {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.franquiaNaoModuloContratado"));

            return this.$router.back();
        }

        this.grupoProdutoOptions = await grupoProdutoService.comboCached(this.usuarioLogado.franquiaId);

        this.loadProdutos();
        await this.loadFornecedores();

        this.isEditableColunaQtdCompra =
            this.model.situacao == SituacaoCompra.Orcamento ||
            this.model.situacao == SituacaoCompra.AguardandoCotacao ||
            this.model.situacao == SituacaoCompra.Analise;
    }
}
